var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 173175",
    xmlns: "http://www.w3.org/2000/svg",
    width: 3.765,
    height: 16,
    viewBox: "0 0 3.765 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 630",
    cx: 1.882,
    cy: 1.882,
    r: 1.882,
    transform: "translate(0 12.235)",
    style: {
      fill: "#203662"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 631",
    cx: 1.882,
    cy: 1.882,
    r: 1.882,
    transform: "translate(0 6.118)",
    style: {
      fill: "#203662"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 632",
    cx: 1.882,
    cy: 1.882,
    r: 1.882,
    style: {
      fill: "#203662"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupNewIcon);
export default __webpack_public_path__ + "static/media/GroupNewIcon.c02898c9ea80299f21a2d06ac85415f8.svg";
export { ForwardRef as ReactComponent };